import { useMemo } from "react";
import {
  InternalAdminUserAttributeCategoryQuery,
  InternalAdminUserAttributeCategoryQueryVariables,
} from "gql/graphql";
import { useQuery } from "@apollo/client";
import INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY_QUERY from "../_networking/internal-admin-user-attribute-category";

const useInternalAdminUserAttributeCategories = (
  id: string | string[] | undefined,
) => {
  const isValid = (Array.isArray(id) && id.length > 0) || !!id;

  const { data, loading } = useQuery<
    InternalAdminUserAttributeCategoryQuery,
    InternalAdminUserAttributeCategoryQueryVariables
  >(INTERNAL_ADMIN_USER_ATTRIBUTE_CATEGORY_QUERY, {
    fetchPolicy: "network-only",
    variables: id
      ? {
          id,
        }
      : undefined,
    skip: !isValid,
  });

  const userAttributeCategories = useMemo(() => {
    if (!data) return [];
    return data.internalAdminUserAttributeCategory;
  }, [data]);

  const userAttributeCategory = useMemo(() => {
    if (userAttributeCategories && userAttributeCategories.length === 1) {
      return userAttributeCategories[0];
    }
    return undefined;
  }, [userAttributeCategories]);

  return {
    userAttributeCategory,
    userAttributeCategories,
    loading,
  };
};

export default useInternalAdminUserAttributeCategories;
